import { BackIcon } from '@ae/icons';
import { useGoBack, useTrackEvent } from '@ae/shared';
import { UIRoundIcon } from '@ae/shared-ui';

type Props = {
  variant?: 'green' | 'white' | 'black';
};

export const UIBackLink = ({ variant = 'white' }: Props) => {
  const goBack = useGoBack();
  const trackEvent = useTrackEvent();

  let iconFill = 'white';
  if (variant === 'green') iconFill = 'ae.green';
  else if (variant === 'black') iconFill = 'black';

  const onClick = () => {
    trackEvent();
    goBack();
  };

  return (
    <UIRoundIcon
      aria-label="back"
      color={iconFill}
      icon={<BackIcon color={variant} />}
      size="sm"
      onClick={onClick}
      sx={{
        _hover: {
          bg: 'ae.pink',
          borderColor: 'ae.pink',
        },
        _active: {
          bg: 'ae.pink',
          borderColor: 'ae.pink',
        },
      }}
    />
  );
};
